import { component } from 'picoapp';
import { gsap } from 'gsap';

export default component((node) => {
  const login = node.querySelector('.js-login');
  const recover = node.querySelector('.js-recover');
  const recoverLink = node.querySelector('.js-recover-trigger');
  const cancelRecoverLink = node.querySelector('.js-recover-cancel');

  const recoverIsTarget = window.location.hash.match(/#recover/);

  const successMessage = node.querySelector('.js-recover-success') !== null;

  const show = (element) => {
    gsap.to(element, { autoAlpha: 1 });
  };

  const hide = (element) => {
    gsap.to(element, { autoAlpha: 0 });
  };

  if (recoverIsTarget || successMessage) {
    hide(login);
    show(recover);
  } else {
    show(login);
  }

  recoverLink.addEventListener('click', (e) => {
    e.preventDefault();
    hide(login);
    show(recover);
  });

  cancelRecoverLink.addEventListener('click', (e) => {
    e.preventDefault();
    hide(recover);
    show(login);
  });
});
